import { render, staticRenderFns } from "./TableStoreDetail.vue?vue&type=template&id=c6d7052a&scoped=true&"
import script from "./TableStoreDetail.vue?vue&type=script&lang=js&"
export * from "./TableStoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./TableStoreDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TableStoreDetail.vue?vue&type=style&index=1&id=c6d7052a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d7052a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VChip,VDataTable,VDialog,VIcon,VImg,VTab,VTabItem,VTabs,VTabsItems})
